import * as url from 'url';

interface UrlDesc {
  protocol?: string;
  hostname: string;
  port?: string;
  pathname?: string;
  query?: any;
}

export class Url {
  static defaultProtocolPorts = {
    http: 80,
    https: 443
  };

  static format(urlDesc: UrlDesc): string {
    if (urlDesc.port) {
      const defaultProtocolPort = Url.defaultProtocolPorts[urlDesc.protocol];
      if (defaultProtocolPort && defaultProtocolPort.toString() === urlDesc.port.toString()) {
        urlDesc.port = null;
      }
    }
    return url.format(urlDesc);
  }
}
